import React from "react";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import PublicNavbar from "components/navbar/public";
import routes from "routes.js";
import { getActiveNavbar, getRoutes, getActiveRoute, filterRoutes } from "../../utils";

const MyPage = ({isCollapse, ...props}) => {
  const { ...rest } = props;
  const location = useLocation();

  const user = useSelector((state) => state.auth.user);
  const modules = useSelector((state) => state.auth.modules);

  const allowedRoutes = React.useMemo(
		() => filterRoutes(routes, user?.user_level, modules, ["/my","/public"]),
		[user?.user_level, modules]
	);

  React.useEffect(() => {
    getActiveRoute(routes, location.pathname);
  }, [location.pathname, getActiveRoute]);

  document.documentElement.dir = "ltr";
  return (
    <div className={`flex h-full w-full`}>
      <div className="page-bg-primary  fixed h-screen w-screen"/>
      {/* Navbar & Main Content */}
      <div className="h-full w-full">
        {/* Main Content */}
        <main
          className={`h-full flex-none transition-all`}
        >
          {/* Routes */}
          <div className="h-full">
            <PublicNavbar
              logoText={"Intsamis"}
              secondary={getActiveNavbar(allowedRoutes)}
              routes={allowedRoutes}
              {...rest}
            />
            <div className="sm:p-4 md:p-6 flex-1 mx-auto mb-auto h-full flex item-center justify-center">
              <Routes>
                {getRoutes(allowedRoutes, ["/public","/my"])}
                <Route
                  index
                  element={<Navigate to="/job-posts" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPage);
